import React from "react";
import { useTranslation } from "react-i18next";
import { UseFormReturn } from "react-hook-form";
import { Card } from "@fluentui/react-components";

// Import form field components
import HookFormTextInputField from "components/controls/HookFormTextInputField";
import HookFormDatePickerField from "components/controls/HookFormDatePickerField";
import HookFormSelectField from "components/controls/HookFormSelectField";
import { useSharedStyles } from "../styles/sharedStyles";

type Props = {
  form: UseFormReturn<any, any>;
  isLoading: boolean;
};

const ContractSection = ({ form, isLoading }: Props) => {
  const { t } = useTranslation();
  const classes = useSharedStyles();

  return (
    <Card className={classes.card}>
      <div className={classes.section}>
        <div className={classes.grid}>
          <div className={classes.sectionTitle}>
            {t("ila.contractInfoSection.title")}
          </div>
          <HookFormTextInputField
            label={t("ila.contractSection.fleetNumber")}
            name="fleetNumber"
            required={true}
            disabled={isLoading}
            control={form.control}
          />
          <HookFormDatePickerField
            label={t("ila.insurance.contractStartDate")} // Update label
            name="insurance.contractStartDate" // Update path
            required={true}
            disabled={isLoading}
            control={form.control}
          />
          <HookFormDatePickerField
            label={t("ila.insurance.startDate")}
            name="insurance.startDate"
            required={true}
            disabled={isLoading}
            control={form.control}
          />
          <HookFormTextInputField
            label={t("ila.leasing.leasingContractNumber")}
            name="leasing.leasingContractNumber"
            required={false}
            disabled={isLoading}
            control={form.control}
          />
          <HookFormTextInputField
            label={t("ila.leasing.replacedContractNumber")}
            name="leasing.replacedContractNumber"
            required={false}
            disabled={isLoading}
            control={form.control}
          />
          <HookFormTextInputField
            label={t("ila.vehicle.value")}
            name="vehicle.value"
            required={true}
            disabled={isLoading}
            control={form.control}
            type="number"
          />
          <HookFormSelectField
            label={t("ila.vehicle.leaseType")}
            name="vehicle.leaseType"
            form={form}
            options={[
              { value: "F", label: t("ila.vehicle.leaseType.financial") }, // Financial leasing
              { value: "O", label: t("ila.vehicle.leaseType.operational") }, // Operational leasing
              { value: "U", label: t("ila.vehicle.leaseType.loan") }, // Loan
            ]}
            required={false}
            disabled={isLoading}
          />
          <HookFormTextInputField
            label={t("ila.vehicle.financingShare")}
            name="vehicle.financingShare"
            required={false}
            disabled={isLoading}
            control={form.control}
            type="number"
          />
          <HookFormSelectField
            label={t("ila.vehicle.leaseFixedRate")}
            name="vehicle.leaseFixedRate"
            form={form}
            options={[
              { value: "A", label: t("ila.yes") }, // Yes
              { value: "N", label: t("ila.no") }, // No
            ]}
            required={false}
            disabled={isLoading}
          />
        </div>
      </div>
    </Card>
  );
};

export default ContractSection;
